import React, { useMemo } from 'react';
import { PurchaseOrderFormValues, QrScannerOutput } from '../../types/types';
import { useAutoPricingState } from './context/AutoPricingProvider';
import { PricingList } from './PricingList';
import { LoadingOverlay } from '../../common/LoadingOverlay/LoadingOverlay';

export const pricingTestId = 'pricingComponent';

export interface PricingListProps {
  readonly purchaseOrder: PurchaseOrderFormValues | null;
  readonly uniqueStates: string[];
  readonly allocations: any;
  qrScannerOutput: QrScannerOutput | undefined;
  readonly disableAutoPricing?: boolean;
  readonly pricingRequestTrigger?: number;
  readonly localSourceProductIndexes?: number[];
}

export const Pricing = ({
  purchaseOrder,
  uniqueStates,
  allocations,
  qrScannerOutput,
  disableAutoPricing,
  pricingRequestTrigger,
  localSourceProductIndexes,
}: PricingListProps) => {
  const { autoPriceLoading } = useAutoPricingState();

  return useMemo(
    () => (
      <>
        {autoPriceLoading && <LoadingOverlay />}
        <div style={{ width: '100%' }} data-testid={pricingTestId}>
          <PricingList
            uniqueStates={uniqueStates}
            allocations={allocations as any}
            purchaseOrder={purchaseOrder}
            qrScannerOutput={qrScannerOutput}
            disableAutoPricing={disableAutoPricing}
            pricingRequestTrigger={pricingRequestTrigger}
            localSourceProductIndexes={localSourceProductIndexes}
          />
        </div>
      </>
    ),
    [
      autoPriceLoading,
      uniqueStates,
      allocations,
      purchaseOrder,
      qrScannerOutput,
      disableAutoPricing,
      pricingRequestTrigger,
      localSourceProductIndexes,
    ]
  );
};
